import Axios from 'axios'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

export const testConnection = async () => {
  return await new Promise(async (resolve) => {
    await Axios({ url: publicRuntimeConfig.apiCheckUrl, baseURL: '' }).then(
      (res) => {
        resolve(true)
      },
      () => {
        resolve(false)
      },
    )
  })
}

export const getAppStatus = async () => {
  return await Axios.get('/health')
}

export const finishMaintenanceApi = async () => {
  return await Axios.post('/catalogConfigs/finishMaintenance')
}
